import { Button, Drawer, Switch } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "../../common/Loader";
import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import { authenticateToken } from "../../../utils/auth";
import PaginationTwo from "../../common/PaginationTwo";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import AddSalesMan from "./AddSupplier";
import SupplierDetails from "./SupplierDetails";

const ShopSupplierList = () => {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [limit, setLimit] = useState(16);
  const [visible, setVisible] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState(undefined);

  const [selectedSupplier, setSelectedSupplier] = useState(undefined);
  const [selectedSupplierForEdit, setSelectedSupplierForEdit] =
    useState(undefined);
  const [shopSupplierData, setShopSupplierData] = useState({
    loading: false,
    data: null,
  });
  const route = useParams();

  const getShopSupplier = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setShopSupplierData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/supplier/by-shop?shopId=${getShopId}` +
              (type ? `?type=${type}` : ``) +
              (status ? `?status=${status}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setShopSupplierData({
                loading: false,
                data: data?.data,
              });
            } else {
              setShopSupplierData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setShopSupplierData({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setShopSupplierData({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  const onDelete = async (id, val) => {
    setConfirmLoading(id);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/supplier`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setConfirmLoading(undefined);
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            setVisible(undefined);
            getShopSupplier("");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    getShopSupplier((route as any)?.shopId);
  }, [getShopSupplier, route]);

  useEffect(() => {
    if (visible) {
      setSelectedSupplier(undefined);
      setSelectedSupplierForEdit(undefined);
    }
  }, [selectedSupplier, selectedSupplierForEdit]);

  useEffect(() => {
    setSelectedSupplier(undefined);
    setSelectedSupplierForEdit(undefined);
  }, [visible]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    setSelectedSupplier(null);
    setSelectedSupplierForEdit(null);
    getShopSupplier((route as any)?.shopId);
  };
  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="product-list-item-area white-bg">
          <ShopHeader
            leftarea={"Supplier List"}
            rightarea={
              <Button
                danger
                type="primary"
                icon={<PlusOutlined />}
                title="Add New"
                onClick={showDrawer}
              >
                Add New
              </Button>
            }
          />
          <div className="product-list-items-inner-content">
            <div className="single-product-wrapper">
              <div className="single-product-heading">
                <span>Supplier</span>
              </div>
              <div className="single-product-heading">
                <span>Contact Number</span>
              </div>
              <div className="single-product-heading">
                <span>Address</span>
              </div>
              <div className="single-product-heading">
                <span>Balance</span>
              </div>
              <div className="single-product-heading">
                <span>Status</span>
              </div>
              <div className="single-product-heading">
                <span>Action</span>
              </div>
            </div>
          </div>

          {shopSupplierData?.loading ? (
            <Loading />
          ) : (
            <div className="product-table">
              <div className="product-table-area">
                {shopSupplierData?.data?.suppliers?.length ? (
                  shopSupplierData?.data?.suppliers?.map(
                    (supplier: any, index: number) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => {
                            setSelectedSupplier(supplier);
                          }}
                        >
                          <div className="single-product">
                            <span className="name">{supplier?.name}</span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {supplier?.mobileNumber?.replace("+88", "")}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {supplier?.address?.substring(0, 30)}...
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              &#2547;{parseInt(supplier?.balance || 0)}
                            </span>
                          </div>
                          <div className="single-product">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked={supplier?.isActive}
                              onChange={(val, e) => {
                                e.preventDefault();
                                onDelete(supplier?.id, val);
                                setVisible(undefined);
                              }}
                              className="mr-1"
                              loading={
                                confirmLoading &&
                                supplier?.id === confirmLoading
                              }
                            />
                          </div>
                          <div className="single-product">
                            <Button
                              onClick={() =>
                                setSelectedSupplierForEdit(supplier)
                              }
                            >
                              <EditOutlined />
                            </Button>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  )
                ) : (
                  <Empty data="Supplier!" />
                )}
              </div>
            </div>
          )}

          <Drawer
            destroyOnClose={true}
            title="Add New"
            width={500}
            onClose={onClose}
            visible={!!visible}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            <AddSalesMan onCloseMethod={onClose} />
          </Drawer>

          <Drawer
            destroyOnClose={true}
            title={
              selectedSupplierForEdit ? "Edit Supplier" : "Supplier Details"
            }
            width={500}
            onClose={onClose}
            visible={selectedSupplier || selectedSupplierForEdit}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            {selectedSupplierForEdit ? (
              <AddSalesMan
                visibleData={selectedSupplierForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <SupplierDetails SupplierDetails={selectedSupplier} />
            )}
          </Drawer>

          <PaginationTwo
            {...shopSupplierData.data}
            limit={limit}
            page={shopSupplierData?.data?.currentPageNumber || 0}
          />
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};

export default ShopSupplierList;
